export const DEFAULT_MAX_STEPS_PER_HISTOGRAM = 50;
export const DEFAULT_IGNORE_OUTLIERS = 0.1;
